import React, {useContext} from "react";
import AppContext from "../context/AppContext";
import FavStar from "./FavStar";
import './DirectoryList.scss'

type Props = {
    loading: boolean
    dirs: VideoDirectory[]
}

export default ({ dirs }: Props) => {
    const { loadDirectory } = useContext(AppContext)

    const visible = dirs.filter(d => !d.name.startsWith('.') && (d.fileCount || d.childCount))

    if (!visible.length) return null

    return (
        <div className="dir-grid">
            {visible.map(dir => (
                <a
                    key={dir.hash}
                    href={`/dir/${dir.hash}`}
                    className="dir-card"
                    onClick={e => loadDirectory(e, dir)}
                >
                    <div className="dir-mosaic">
                        {(dir.files || []).slice(0, 4).map((f, i) => (
                            <div
                                key={f.hash}
                                className={'dir-mosaic-cell' + (f.fileType === 'circle' ? ' is-circle' : '')}
                                style={{ backgroundImage: `url(${f.paths.thumbnail})` }}
                            />
                        ))}
                    </div>
                    <span className="dir-count">
                        {dir.fileCount ?? (dir.files?.length ?? 0)}
                    </span>
                    <div className="dir-info">
                        <span className="dir-name">{dir.name}</span>
                        <FavStar directory={dir}/>
                    </div>
                </a>
            ))}
        </div>
    )
}
